import { render, staticRenderFns } from "./ListPost.vue?vue&type=template&id=dc317afa&"
import script from "./ListPost.vue?vue&type=script&lang=js&"
export * from "./ListPost.vue?vue&type=script&lang=js&"
import style0 from "./ListPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports